import React from 'react';
import PropTypes from 'prop-types';
import WpBlogTemplate from '../WpBlogPageTemplate';

const PaginatedWpBlogTagTemplate = ({ pageContext }) => {
  const { node } = pageContext;

  return (
    <WpBlogTemplate
      paginationBasePath={`${node.basePath}`}
      totalPosts={pageContext.totalPosts}
      blogPosts={node.posts}
      title={node.name}
      metaTitle={`Blog | Oasis living - Blog Tags | ${node.name} | ${pageContext.pageNumber}`}
      metaDescription={`Get specific advise on property subjects by choosing from one of our blog tags. From finding tenants, property management and property law | ${node.name} | ${pageContext.pageNumber}`}
      currentPage={pageContext.pageNumber}
      latestBlogposts={pageContext.latestBlogposts}
      latestPodcasts={pageContext.latestPodcasts}
      specialEventPost={pageContext.specialEventPost}
      featuredPodcast={pageContext.featuredPodcast}
    />
  );
};

PaginatedWpBlogTagTemplate.propTypes = {
  data: PropTypes.object,
  pageContext: PropTypes.object,
};

export default PaginatedWpBlogTagTemplate;
